@if (
  {
    hasShiftBeenValidated:
      shiftCardTooltipStateService.hasShiftBeenValidated$ | async,
    isLoadingValidations:
      (shiftCardTooltipStateService.isLoadingValidationsForUser$ | async) ||
      (shiftCardTooltipStateService.isShiftValidationLoading$ | async),
    isLoadingValidationsV1Error:
      shiftCardTooltipStateService.isLoadingValidationsV1Error$ | async,
    isShiftValid: shiftCardTooltipStateService.isShiftValid$ | async,
    currentShift: shiftCardTooltipStateService.currentShift$ | async,
  };
  as data
) {
  @if (showShiftValidation) {
    <div>
      @if (!data.isLoadingValidations || data.hasShiftBeenValidated) {
        <div>
          <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
        </div>
      } @else {
        <wilson-timeline-shift-tooltip
          [shift]="data.currentShift"
          [plannedShiftStartDateTime]="plannedShiftStartDateTime"
          [plannedShiftEndDateTime]="plannedShiftEndDateTime"
          [accurateShiftStartDateTime]="accurateShiftStartDateTime"
          [accurateShiftEndDateTime]="accurateShiftEndDateTime"
          [shiftStartTimeDifference]="shiftStartTimeDifference"
          [shiftEndTimeDifference]="shiftEndTimeDifference"
          [shiftStartTimeType]="shiftStartTimeType"
          [shiftEndTimeType]="shiftEndTimeType"
          [plannedStartLocation]="plannedStartLocation"
          [plannedEndLocation]="plannedEndLocation"
          [reportedStartLocation]="reportedStartLocation"
          [reportedEndLocation]="reportedEndLocation"
          [renderingLoadingOrValidations]="true"
        >
          <nz-skeleton
            class="mt-3"
            [nzActive]="true"
            [nzTitle]="{ width: 'small' }"
            [nzParagraph]="{ rows: 2, width: 'default' }"
          ></nz-skeleton>
        </wilson-timeline-shift-tooltip>
      }
    </div>
  } @else {
    <wilson-timeline-shift-tooltip
      [shift]="data.currentShift"
      [plannedShiftStartDateTime]="plannedShiftStartDateTime"
      [plannedShiftEndDateTime]="plannedShiftEndDateTime"
      [accurateShiftStartDateTime]="accurateShiftStartDateTime"
      [accurateShiftEndDateTime]="accurateShiftEndDateTime"
      [shiftStartTimeDifference]="shiftStartTimeDifference"
      [shiftEndTimeDifference]="shiftEndTimeDifference"
      [shiftStartTimeType]="shiftStartTimeType"
      [shiftEndTimeType]="shiftEndTimeType"
      [plannedStartLocation]="plannedStartLocation"
      [plannedEndLocation]="plannedEndLocation"
      [reportedStartLocation]="reportedStartLocation"
      [reportedEndLocation]="reportedEndLocation"
    >
    </wilson-timeline-shift-tooltip>
  }
  <ng-template #tooltipTemplate>
    <wilson-timeline-shift-tooltip
      [shift]="data.currentShift"
      [plannedShiftStartDateTime]="plannedShiftStartDateTime"
      [plannedShiftEndDateTime]="plannedShiftEndDateTime"
      [accurateShiftStartDateTime]="accurateShiftStartDateTime"
      [accurateShiftEndDateTime]="accurateShiftEndDateTime"
      [shiftStartTimeDifference]="shiftStartTimeDifference"
      [shiftEndTimeDifference]="shiftEndTimeDifference"
      [shiftStartTimeType]="shiftStartTimeType"
      [shiftEndTimeType]="shiftEndTimeType"
      [plannedStartLocation]="plannedStartLocation"
      [plannedEndLocation]="plannedEndLocation"
      [reportedStartLocation]="reportedStartLocation"
      [reportedEndLocation]="reportedEndLocation"
      [renderingLoadingOrValidations]="true"
    >
      <wilson-timeline-shift-validation-tooltip
        [noValidationFound]="data.isLoadingValidationsV1Error ?? false"
        [workingTimeValidations]="
          shiftCardTooltipStateService.workingTimeValidations$ | async
        "
        [shiftLogicValidations]="
          shiftCardTooltipStateService.shiftLogicValidations$ | async
        "
        [qualificationNames]="
          shiftCardTooltipStateService.qualificationNames$ | async
        "
        [professionValidations]="
          shiftCardTooltipStateService.professionValidations$ | async
        "
      ></wilson-timeline-shift-validation-tooltip>
    </wilson-timeline-shift-tooltip>
  </ng-template>
}
